import theme from '@ifca-root/react-component/src/assets/theme'
import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  useMediaQuery,
  withStyles,
} from '@material-ui/core'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import { CardExpansionHeader } from 'components/CardExpansion/CardExpansionHeader'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import { SubmitterDialog } from 'components/Dialog/SubmitterDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  GetArScheduledBillingbyStatusListingDocument,
  usePostArScheduledBillingMutation,
  useRejectArScheduledBillingMutation,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate, formatTime } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useParams } from 'react-router'
import { ARScheduledBillingDetailContent } from '../ARScheduledBillingDetail/ARScheduledBillingDetailContent'

export const ARScheduledBillingPostingList = (props: any) => {
  const {
    filteredList,
    ScheduledBillingbyStatusLoading,
    listStatus,
    postIDs,
    setPostIDs,
    userList,
    setOriginalListing,
    fetchMore,
    setErrMessage,
    setErrDialog,
    // include when isProforma is done
  } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const { CompanyID }: any = useParams()
  const { menu: menu2 }: any = useMenuOption()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */

  const [openDialog, setOpenDialog] = useState(false)
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const [clickReject, setIsReject] = useState(false)
  const [rejectDialogInput, setRejectDialogInput] = useState({
    RejectionRemark: '',
  })
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const { handleSubmit } = useForm({
    mode: 'onSubmit',
  })

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const [
    postARScheduledBilling,
    { loading: postARScheduledBillingLoading },
  ] = usePostArScheduledBillingMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.postNewRecord())
      setPostIDs(new Set([]))
      setOriginalListing([])
      fetchMore({
        variables: {
          CompanyID,
          StatusArr: [listStatus],
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name === '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  const [
    rejectARScheduledBilling,
    { loading: rejectJournalProcessingLoading },
  ] = useRejectArScheduledBillingMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.rejectNewRecord())
      setPostIDs(new Set([]))
      setOriginalListing([])
      fetchMore({
        variables: {
          CompanyID,
          StatusArr: [listStatus],
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name === '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  /* -------------------------------------------- */
  /*                    VARIABLE                  */
  /* ---------------------------------------=---- */

  const handleSelectAll = e => {
    let jTemp = postIDs
    if (e.target.checked) {
      filteredList.map(v => {
        jTemp.add(v?.ScheduledBillingID)
      })
    } else {
      jTemp.clear()
    }
    setPostIDs(new Set(jTemp))
  }

  const handleCheckBoxChange = (e: any, postID, index: number) => {
    let temp = postIDs
    if (!temp.has(postID)) {
      temp.add(postID)
    } else {
      temp.delete(postID)
    }
    setPostIDs(new Set(temp))
  }

  const GreyTooltip = withStyles({
    tooltip: {
      color: 'white',
      backgroundColor: '#9e9e9e',
    },
  })(Tooltip)

  let listPostIDs: any = Array.from(postIDs || [])

  let checkedData = []
  listPostIDs.map(ID => {
    filteredList.map((el, i) => {
      if (el?.ScheduledBillingItemID === ID) {
        checkedData.push(...el?.ScheduledBillingItemID)
      }
    })
  })

  useEffect(() => {
    if (clickReject) {
      onSubmitReject()
    }
  }, [clickReject])

  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()
  /**ACL */

  /* -------------------------------------------- */
  /*                    SUBMIT                    */
  /* -------------------------------------------- */
  const onSubmitApprove = (listPostIDs, status) => {
    postARScheduledBilling({
      variables: {
        ScheduledBillingIDs: listPostIDs,
        ApprovalStatus: status,
      },
      refetchQueries: [
        {
          query: GetArScheduledBillingbyStatusListingDocument,
          variables: {
            CompanyID,
            StatusArr: [ApprovalStatus.Submit],
          },
        },
      ],
    })
  }

  const onSubmitReject = () => {
    rejectARScheduledBilling({
      variables: {
        ScheduledBillingIDs: listPostIDs,
        input: {
          RejectionRemark: rejectDialogInput?.RejectionRemark,
        },
      },
      refetchQueries: [
        {
          query: GetArScheduledBillingbyStatusListingDocument,
          variables: {
            CompanyID,
            StatusArr: [ApprovalStatus.Submit],
          },
        },
      ],
    })
  }

  return (
    <>
      {postARScheduledBillingLoading && <Loading />}
      {rejectJournalProcessingLoading && <Loading />}
      {ScheduledBillingbyStatusLoading && <Loading />}
      <ContentWrapper
        style={{ marginTop: isDesktop ? '70px' : '-7px' }}
        overflow
      >
        {listStatus === 'SUBMIT' && filteredList?.length !== 0 ? (
          <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
            <Checkbox
              onChange={handleSelectAll}
              color="primary"
              value={''}
              checked={postIDs?.size === filteredList?.length}
              style={{ marginLeft: '-5px', marginTop: '-5px' }}
              disabled={handlePermDisabled({
                companyID: CompanyID,
                permEnum:
                  AcctPermission.AccReceivableSalesOrderBillingScheduleApproveReject,
              })}
            />
            <span style={{ marginLeft: '9px' }}>Select All</span>
          </span>
        ) : null}

        <List className="core-list">
          {filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name !== '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={true}
              // className=""
              style={{ padding: '8px 6px' }}
              loader={
                ScheduledBillingbyStatusLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {filteredList?.map((el, index) => {
                return (
                  <CardExpansion
                    summary={
                      <ListItem key={index}>
                        {listStatus === 'SUBMIT' ? (
                          <FormControl
                            component="fieldset"
                            style={{ width: '16px' }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  value={el.ScheduledBillingID}
                                  onChange={e => {
                                    handleCheckBoxChange(
                                      e,
                                      el?.ScheduledBillingID,
                                      index
                                    )
                                  }}
                                  onClick={e => e.stopPropagation()}
                                  checked={postIDs?.has(el?.ScheduledBillingID)}
                                  color="primary"
                                  style={{
                                    marginLeft: '10px',
                                    marginRight: '-5px',
                                  }}
                                  disabled={handlePermDisabled({
                                    companyID: CompanyID,
                                    permEnum:
                                      AcctPermission.AccReceivableSalesOrderBillingScheduleApproveReject,
                                  })}
                                />
                              }
                              label=""
                              name="check"
                            />
                          </FormControl>
                        ) : null}

                        <ListItemText
                          style={{
                            marginLeft: listStatus === 'SUBMIT' ? '25px' : null,
                          }}
                          primary={
                            <>
                              <span className={`xsTitle flex-space`}>
                                {el?.DebtorAccount?.DebtorName}
                              </span>
                              <span
                                className="desc"
                                style={{ justifyContent: 'end' }}
                              >
                                {`${formatDate(el?.createdTs)}`}
                              </span>
                            </>
                          }
                          secondary={
                            <Grid
                              container
                              className="desc flex-space text-noflow"
                            >
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={9}>
                                  <span style={{ fontSize: '10px' }}>
                                    {el?.SalesOrder?.title}
                                  </span>
                                </Grid>
                                <Grid item xs={3}>
                                  <IconText
                                    parentStyle={{ justifyContent: 'end' }}
                                    font="xxTitle c-orange"
                                    children={amtStr(
                                      el?.BillingAmt ??
                                        el?.ScheduledBillingItem?.reduce(
                                          (prevValue, currentValue) =>
                                            prevValue + currentValue?.DocAmt,
                                          0
                                        )
                                    )}
                                  />
                                </Grid>
                              </Grid>

                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={12}>
                                  <div className="icon-text">
                                    <Tooltip
                                      disableFocusListener
                                      title={
                                        <Fragment>
                                          <Grid
                                            container
                                            wrap="nowrap"
                                            spacing={2}
                                          >
                                            <Grid item>
                                              <IconText
                                                icon={
                                                  <img
                                                    src={SubmitterLog}
                                                    style={{
                                                      width: '12px',
                                                      marginRight: '3px',
                                                    }}
                                                  />
                                                }
                                                font="desc"
                                              />
                                            </Grid>
                                            <Grid item xs zeroMinWidth>
                                              <div style={{ fontSize: '12px' }}>
                                                {userList?.find(
                                                  x => x?.ID === el?.submittedBy
                                                )?.name ??
                                                  userList?.find(
                                                    x => x?.ID === el?.modBy
                                                  )?.name}
                                              </div>
                                              <div style={{ fontSize: '10px' }}>
                                                {formatDate(
                                                  el?.submittedTs ?? el?.modTs
                                                )}{' '}
                                                &nbsp;
                                                {formatTime(
                                                  el?.createdTs ?? el?.modTs
                                                )}
                                              </div>
                                            </Grid>
                                          </Grid>
                                        </Fragment>
                                      }
                                      arrow
                                      enterTouchDelay={0}
                                    >
                                      <div>
                                        <IconText
                                          icon={
                                            <img
                                              src={SubmitterLog}
                                              style={{
                                                width: '12px',
                                                marginRight: '3px',
                                              }}
                                            />
                                          }
                                          font="desc"
                                        />
                                      </div>
                                    </Tooltip>
                                    <span className="desc text-noflow">
                                      {!el?.SalesOrder?.remarks?.trim()
                                        ? 'N/A'
                                        : el.SalesOrder.remarks}
                                    </span>
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          }
                        />
                      </ListItem>
                    }
                  >
                    {
                      <>
                        <ARScheduledBillingDetailContent
                          listEl={el}
                          listStatus={'SUBMIT'}
                          userList={userList}
                          mode={'expansion'}
                        />
                        <CardExpansionHeader title={'Billing Schedule'} />
                        <SBItemDetailContent
                          listItem={el?.ScheduledBillingItem}
                        />
                      </>
                    }
                  </CardExpansion>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
        <div style={{ marginBottom: '100px' }}></div>
      </ContentWrapper>

      <SubmitterDialog
        data={menu2?.obj}
        setOpenDialog={setOpenDialog}
        openDialog={openDialog}
        moduleName={'Schedule Billing'}
      />

      <RejectDialog
        data={filteredList}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        setRejectDialogInput={setRejectDialogInput}
        setIsReject={setIsReject}
      />

      {listStatus === 'SUBMIT' ? (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => {
                setOpenRejectDialog(true)
              },
              color: 'secondary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum:
                      AcctPermission.AccReceivableSalesOrderBillingScheduleApproveReject,
                  }),
              },
            },
            {
              name: 'Approve',
              onClick: () => {
                onSubmitApprove(listPostIDs, ApprovalStatus.Completed)
              },
              color: 'primary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum:
                      AcctPermission.AccReceivableSalesOrderBillingScheduleApproveReject,
                  }),
              },
            },
          ]}
        />
      ) : null}
    </>
  )
}

const SBItemDetailContent = ({ listItem }) => {
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      <div className="rm-padding table-wrap ">
        {listItem
          ?.filter(x => x?.DocAmt !== 0)
          ?.map((el, index) => {
            return (
              <>
                {/* First Row */}
                <Grid spacing={1} container className="table-content">
                  <Grid item xs={1} style={{ placeSelf: 'start' }}>
                    <span className="xxTitle">{`${index + 1}.`}</span>
                  </Grid>

                  <Grid
                    item
                    xs={8}
                    style={{ placeSelf: 'start', marginTop: '8px' }}
                  >
                    <div className="mdDesc text-noflow">
                      {el?.BillItem?.Name}
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={3}
                    style={{
                      placeSelf: 'start',
                      marginTop: '8px',
                      marginRight: 'auto',
                      textAlign: 'right',
                      flexWrap: 'wrap',
                      display: 'flex',
                      justifyContent: isDesktop ? 'end' : 'end',
                    }}
                  >
                    <div className="mdDesc">
                      {el.DocAmt < 0
                        ? `(${amtStr(el.DocAmt)})`
                        : amtStr(el.DocAmt)}
                    </div>
                  </Grid>
                </Grid>

                {/* Second Row */}
                <Grid spacing={1} container className="table-content">
                  <Grid item xs={1} style={{ placeSelf: 'start' }} />
                  <Grid
                    item
                    xs={5}
                    style={{ placeSelf: 'start', marginTop: '-18px' }}
                  >
                    <div className="desc text-noflow c-grey">
                      {formatDate(el?.ScheduledBillingDate)}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{ placeSelf: 'start', marginTop: '-18px' }}
                  >
                    <div className="desc c-grey">
                      {`${el?.TaxScheme?.Name}`}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{
                      placeSelf: 'start',
                      marginTop: '-18px',
                      marginRight: 'auto',
                      textAlign: 'right',
                      flexWrap: 'wrap',
                      display: 'flex',
                      justifyContent: isDesktop ? 'end' : 'end',
                    }}
                  >
                    <div className="desc text-noflow c-grey">
                      {amtStr(el?.BillingAmt)}
                    </div>
                  </Grid>
                </Grid>

                {/* Third Row */}
                <Grid spacing={1} container className="table-content">
                  <Grid item xs={1} style={{ placeSelf: 'start' }} />
                  <Grid
                    item
                    xs={8}
                    style={{ placeSelf: 'start', marginTop: '-18px' }}
                  >
                    <div className="desc text-noflow c-grey">
                      {el?.Description}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{
                      placeSelf: 'start',
                      marginTop: '-18px',
                      marginRight: 'auto',
                      textAlign: 'right',
                      flexWrap: 'wrap',
                      display: 'flex',
                      justifyContent: isDesktop ? 'end' : 'end',
                    }}
                  >
                    <div className="desc text-noflow c-grey">
                      {amtStr(el?.TaxAmt)}
                    </div>
                  </Grid>
                </Grid>

                {index !== listItem?.length - 1 && (
                  <Divider
                    variant="fullWidth"
                    style={{ background: '#E4E4E4' }}
                  />
                )}
              </>
            )
          })}
      </div>
    </>
  )
}
